'use client';

import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const body1StrongerClassNames = {
  root: 'fui-Body1Stronger'
};
/**
 * Styles for the root slot
 */
export const useBody1StrongerStyles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "flh3ekv",
    Bg96gwp: "f1i3iumi"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".flh3ekv{font-weight:var(--fontWeightBold);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}"]
});